import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AdminService } from './api/admin.service';
import { AuthService } from './api/auth.service';
import { CertService } from './api/cert.service';
import { CircuitService } from './api/circuit.service';
import { CustomCircuitService } from './api/customCircuit.service';
import { DocumentService } from './api/document.service';
import { EvidenceService } from './api/evidence.service';
import { IvSignService } from './api/ivSign.service';
import { OperationService } from './api/operation.service';
import { OrganizationService } from './api/organization.service';
import { UserService } from './api/user.service';

@NgModule({
    imports: [],
    declarations: [],
    exports: [],
    providers: [
        AdminService,
        AuthService,
        CertService,
        CircuitService,
        CustomCircuitService,
        DocumentService,
        EvidenceService,
        IvSignService,
        OperationService,
        OrganizationService,
        UserService]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [{ provide: Configuration, useFactory: configurationFactory }]
        };
    }

    constructor(@Optional() @SkipSelf() parentModule: ApiModule,
        @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
                'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
